import {create} from 'zustand';
import {OperationalCostStore, OperationalCostErrorMessageStore} from './types';

const useOperationalCostStore = create<OperationalCostStore>(set => ({
	isOperationalCostAuthorized: false,
	setIsOperationalCostAuthorized: value => set({isOperationalCostAuthorized: value}),
	resetIsOperationalCostAuthorized: () => set({isOperationalCostAuthorized: false}),
}));

const useOperationalCostErrorMessageStore = create<OperationalCostErrorMessageStore>(set => ({
	errorMessage: '',
	setErrorMessage: msg => set({errorMessage: msg}),
}));

export {useOperationalCostStore, useOperationalCostErrorMessageStore};
